module.exports = __webpack_public_path__ + "static/media/icon-visa-24px.59e70bf3.svg";